import { PERMISSIONS, hasPermission } from '@helios/authz';
import { railPathFor, userCanAccessDestination } from '@/navigation/registry';
import type { NavDomain } from '@/navigation/types';

export interface LandingPageOption {
  path: string;
  label: string;
}

/**
 * Landing-page choices mirror what each rail row actually opens. A hub row the
 * user cannot open directly (Relationships for a client- or vendor-only role)
 * offers its first permitted tab, which is the path the API will accept.
 */
export function landingPageOptions(
  groups: readonly NavDomain[],
  permissions: readonly string[],
): LandingPageOption[] {
  const railOptions = groups.flatMap((group) =>
    group.items
      .map((item) => ({
        path: userCanAccessDestination(item, permissions)
          ? item.path
          : railPathFor(item, permissions),
        label: `${group.label} / ${item.label}`,
      }))
      .filter((option) => !option.path.includes(':') && option.path !== '/'),
  );
  return [
    { path: '/', label: 'Default permitted workspace' },
    ...railOptions,
    { path: '/settings/preferences', label: 'Preferences' },
    ...(hasPermission(permissions, PERMISSIONS.NOTIFICATIONS_READ)
      ? [{ path: '/settings/notifications', label: 'Notifications' }]
      : []),
  ].filter((option, index, all) => all.findIndex((other) => other.path === option.path) === index);
}
